import { FC } from "react"
import ReactSelect, { GroupBase, OptionsOrGroups } from "react-select"
import ArrowDown from '@/shared/assets/images/ArrowDown.svg'

interface SelectProps {
    isLoading?: boolean
    options: OptionsOrGroups<any, GroupBase<any>>
    onChange: (value: any) => void
    className?: string
    value: any
    isMulti?: boolean
    placeholder?: string
}

export const Select: FC<SelectProps> = ({ isLoading, isMulti, placeholder, options, onChange, className, value }) => {
    return (
        <ReactSelect
            className={`w-full text-color-dark flex items-center px-4 h-[52px] bg-white rounded-full ${className}`} 
            options={options}
            classNames={{
                control: () => '!border-0 !p-0 !outline-0 !min-h-[auto] w-full !border-transparent !shadow-none',
                valueContainer: () => '!border-0 !outline-0 !p-0',
                menu: () => '!left-[0]',
                groupHeading: () => 'text-2xl font-mediumttf !text-color-dark border-b pb-2'
            }}
            isMulti={isMulti}
            placeholder={placeholder}
            isLoading={isLoading}
            classNamePrefix="react_select_custom"
            noOptionsMessage={() => 'Нет опций'}
            components={{
                DropdownIndicator: () => <ArrowDown height={20} width={20}/>,
                IndicatorSeparator: () => null
            }}
            value={isMulti ? value : options.find(option => option.value === value)}
            onChange={(e) => isMulti ? onChange(e) : onChange(e.value)}
        />
    )
}